export class CalcfondRequestModel {

  public Statistiknummer: number;
  public VersDauer: number;
  public YearOfBirth: number;
  public YearOfBirth1: number;
  public Zahlweise: number;
  public OptimizeValue: number;
  public AblSumPercent: number;
  public Geschlecht_VP1: number;
  public HIOs: number;
  public PolUgovarac: number;
  public UtzOs: number;
  public UI: number;
  
  public type: number;
  
 
}



// WEBPACK FOOTER //
// ./src/app/models/calcfond-request.model.ts